import { render, staticRenderFns } from "./exchangeDetail.vue?vue&type=template&id=0876a513&scoped=true&"
import script from "./exchangeDetail.vue?vue&type=script&lang=js&"
export * from "./exchangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./exchangeDetail.vue?vue&type=style&index=0&id=0876a513&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876a513",
  null
  
)

export default component.exports